/*
  Volvik Rebuy free-gift guard, v3 (2026-09-28, InVig). Theme asset: assets/laborday-free-gift.js
  (loaded from snippets/meta-tags.liquid). v3 = v2 made gift-aware so it stops deleting the BCRF free Unity.

  Why v3: Rebuy GWP widget 308391 now gives 2 gifts: USA 250 dozen with the All-American Bundle (Patriot rule)
  AND BCRF Unity with the Pink Power Bundle (Rule #2, added 9/27). v2 treated EVERY widget-308391 line as the
  USA 250 gift and removed it whenever no All-American Bundle was in the cart, so it deleted the free Unity
  ~3 s after Rebuy added it (reproduced live 9/28, see volvik-speed-0928/gift-guard-test.log).

  Rules (remove-only, same as v2): a gift line stays only while its own qualifying bundle is in the cart,
  max 1 per order, duplicates removed. Gift lines for products not listed below are left alone.
    10445798604984 Power Soft USA 250 Years dozen  <- 10445814104248 All-American Bundle
    10569019130040 BCRF Unity Pink Golf Balls     <- 10169932349624 Pink Power Bundle
*/
(function () {
  var GIFT_WIDGET_ID = "308391";
  var GIFT_RULES = {
    10445798604984: [10445814104248],
    10569019130040: [10169932349624]
  };
  var MIN_QTY = 1;
  var MAX_GIFT_QTY = 1;
  var busy = false;

  function isRebuyGift(item) {
    if (!item.properties) return false;
    if (item.properties._widget_id === GIFT_WIDGET_ID) return true;
    return (
      item.properties._source === "Rebuy" &&
      item.properties._attribution === "Rebuy Gift with Purchase" &&
      GIFT_RULES.hasOwnProperty(item.product_id)
    );
  }

  function refreshCartUI() {
    try {
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.refresh == "function")
        return window.Rebuy.SmartCart.refresh();
    } catch (e) {}
    try {
      if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.refresh == "function")
        return window.Rebuy.Cart.refresh();
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (e) {}
  }

  function change(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(refreshCartUI);
  }

  function sync() {
    if (busy) return;
    busy = true;
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var qty = {};
        var gifts = {};
        items.forEach(function (item) {
          if (isRebuyGift(item) && GIFT_RULES.hasOwnProperty(item.product_id)) {
            (gifts[item.product_id] = gifts[item.product_id] || []).push(item);
            return;
          }
          qty[item.product_id] = (qty[item.product_id] || 0) + item.quantity;
        });
        for (var giftId in gifts) {
          var lines = gifts[giftId];
          var qualifying = 0;
          GIFT_RULES[giftId].forEach(function (pid) { qualifying += qty[pid] || 0; });
          if (qualifying < MIN_QTY) return change(lines[0].key, 0);
          if (lines[0].quantity > MAX_GIFT_QTY) return change(lines[0].key, MAX_GIFT_QTY);
          if (lines.length > 1) return change(lines[1].key, 0);
        }
      })
      .catch(function () {})
      .then(function () { busy = false; }, function () { busy = false; });
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = origFetch.apply(this, arguments);
    if (typeof url == "string" && /\/cart\/(add|change|update|clear)/.test(url) && p && p.then) {
      p.then(function () { setTimeout(sync, 600); }, function () {});
    }
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url == "string" && /\/cart\/(add|change|update|clear)/.test(url)) {
      this.addEventListener("load", function () { setTimeout(sync, 600); });
    }
    return origOpen.apply(this, arguments);
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", sync);
  else sync();
  setInterval(sync, 8000);
})();